module.exports = __webpack_public_path__ + "static/media/profile_color.f365e1a2.svg";